import { MatDialog } from "@angular/material/dialog";
import { AdminsApi, Metadata } from "src/app/hickory-api";
import { AuthZAccessControl } from "../../../authentication/access-control";
import { AuthService } from "../../../authentication/auth.service";
import { SelectUsersComponent, SelectUsersData } from '../../../select-users/select-users.component';
import { AdminAuthZCollection } from '../shared-authz-models';

export class PeopleAuthZCollection extends AdminAuthZCollection {

  override get can() { return AuthZAccessControl.canAccessAuthZType(this.auth, 'people'); }

  public override get addButton() {
    return {
      show: this.can,
      icon: 'person_add',
      localizationKey: 'Admins.Management.Authorization.AddPersonButton'
    };
  }

  constructor(
    private auth: AuthService,
    service: AdminsApi,
    metadata: Metadata,
    dialog: MatDialog,
    actions: string[]
  ) {
    super(
      parseInt(metadata.tenantId) || auth.user.snapshot.tenantId,
      actions, metadata, 'People', 'person',
      service, dialog, SelectUsersComponent
    )
  }

  protected override buildDialogData(): SelectUsersData {
    return this.buildSelectUsersData('Grant Access to People', 'Grant Access', false);
  }
}
